import React, { Component } from "react"
import { Link } from "react-router-dom"
import { Helmet } from "react-helmet"
import PropTypes from "prop-types"
import axios from "axios"
import logo from '../images/logo_RT132.png';
import moment from 'moment';
import tw,  { styled }  from  'twin.macro'
import { ReactComponent as Arrow } from "../assets/arrow.svg"
import localization from 'moment/locale/nl';

import Title from "../components/global/Title/Title"
import Label from "../components/global/Label/Label"
import InitiativesCard from "../components/home/Initiatives/InitiativesCard"
import Share from "../components/global/Share/Share"
// import Content from "../components/global/Content/Content"
import Animation from "../components/global/Animation/Animation"

import { Loader } from "../components/common/Loader/Loader"

const Content = styled.div`
  ${tw`
    leading-loose
  `}
  p {
    ${tw`
      text-gray-500 my-8
    `}
  }
  img {
    ${tw`
      w-full rounded-lg
    `}
  }
  figure {
    ${tw`
      w-full
    `}
  }
`;

export default class InitiativesDetailScreen extends Component {
  constructor(props){
    super(props);
    this.state = {
      dataAll: [],
      data: [],
      loading: false,
    };
  }

  componentDidMount() {
    const { match } = this.props
    this.loadData({ match })
  }

  componentDidUpdate(prevProps) {
    const { match } = this.props
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.loadData({ match })
    }
  }

  loadData = ({ match }) => {
    this.setState({loading: true})
    axios.all([
      axios.get(`/wp-json/wp/v2/initiatieven?slug=${match.params.initiatief_slug}`),
      axios.get(`/wp-json/wp/v2/initiatieven`),
    ])
    .then(axios.spread((resData, resDataAll) => {
      this.setState({
        data: resData.data[0],
        dataAll: resDataAll.data,
        loading: false
      })
    }))
    .catch(error => {
      console.log(error)
    });

  }

  render() {
    const { data, dataAll, loading } = this.state
    const { match } = this.props

    const allInits = []
    if(dataAll && dataAll.length > 0) {
      const filteredDataAll = dataAll.filter(item => (item.id !== match.params.id))
      for(let i = 0; i < 2; i++){
        filteredDataAll.reduce((a, c, i, o) => {
          if(allInits[i] !== (a && a.id)) {
            allInits.push(o[Math.floor(Math.random() * Math.floor(o.length))]);
          }
        })
      }
    }

    return (
      loading === true ? <Loader/> :
      <div>
        <Helmet>
          <title>{data.yoast_title && data.yoast_title}</title>
          <meta name={data.yoast_meta && data.yoast_meta[0].name} content={data.yoast_meta && data.yoast_meta[0].content} />
        </Helmet>
        <section className="relative p-0 pt-16">
          <Animation/>
          <div className="max-w-screen-xl mx-auto px-4 sm:px-6 md:flex md:flex-wrap lg:px-8 z-10 relative">
            <div className="ml-1-col md:w-1/2 py-32">
              <div className="breadcrumb-bar" style={{color: "#F58120"}}>
                <div className="breadcrumb"><Link to="/">Home</Link><div className="px-2 breadcrumb-seperator"><Arrow/></div></div>
                <div className="breadcrumb"><Link to="/initiatieven">Initiatieven</Link><div className="px-2 breadcrumb-seperator"><Arrow/></div></div>
                <div className="breadcrumb" style={{color: "#000"}} dangerouslySetInnerHTML={{__html: data.title && data.title.rendered }}/>
              </div>
              <Title className="underlined" level="1">{ data.title && data.title.rendered }</Title>
            </div>
          </div>
        </section>
        <section className="relative pt-0">
          <div className="max-w-screen-xl mx-auto md:px-6 md:flex md:flex-wrap lg:px-8">
            <div className="md:flex flex-no-wrap md:-mx-4">
              <div className="md:w-8/12 px-4">

                <div className="bg-lightorange rounded-lg p-8 md:p-24">
                  <Label>{moment(data.date).locale('nl', localization).format('LL')}</Label>
                  <Content dangerouslySetInnerHTML={{ __html: data.content && data.content.rendered }} />
                  <Share/>
                </div>
              </div>
              <div className="md:w-4/12 px-4">
                { allInits && allInits.slice(0, 2).map(prop => {
                  return (
                    <div key={prop.id} dataindex={prop.id}>
                      <div className="w-full block mb-8">
                        <InitiativesCard title={prop.title && prop.title.rendered} label={prop.date} link={`/${prop.type}/${prop.slug}/`} imageSrc={prop.better_featured_image ? prop.better_featured_image.source_url : logo}/>
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
        </section>
      </div>
    )
  }
}

InitiativesDetailScreen.propTypes = {
  id: PropTypes.string
};
